import React from 'react';
import { Table } from 'react-bootstrap';
import { floatRenderer } from '../../services/formatSvc';

export default function BudgetTableSf({ data, finSource }) {
  const renderRow = (d) => {
    const sfSource = finSource.sources.sf.find((sf) => sf.id === d.sfSourceId);
    const funding = finSource.sources.funding.find(
      (fund) => fund.id === d.fundingId,
    );

    return (
      <tr key={d.id}>
        <td>{sfSource.name}</td>
        <td />
        <td>{funding && funding.name}</td>
        <td>{floatRenderer(d.sum)}</td>
        <td>{floatRenderer(d.paymentSum)}</td>
      </tr>
    );
  };

  const addRow = () => {
    const a = [];
    data.forEach((element) => {
      a.push(element.sfSourceId);
    });
    const b = finSource.sources.sf.filter((e) => !a.includes(e.id));
    return (
      <>
        {b.map((e, i) => (
          <tr key={i}>
            <td>{e.name}</td>
            <td />
            <td />
            <td>0</td>
            <td>0</td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <Table striped className="read-view" style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>Источник</th>
          <th />
          <th>Тип софинансирования</th>
          <th>План, руб</th>
          <th>Факт, руб.</th>
        </tr>
      </thead>
      <tbody>
        {data.map(renderRow)}
        {addRow()}
      </tbody>
    </Table>
  );
}
